"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "login": {
    "onlineTraining": "Liaogao e college online training platform",
    "captchaNotEmpty": "Verification code cannot be empty",
    "accountNotEmpty": "Account number cannot be empty",
    "passwordBits": "Password length cannot be less than 6 digits",
    "incorrectTips": "Wrong user name or password entered",
    "sign": "Login",
    "passwordNotEmpty": "Password cannot be empty",
    "passwordBitsLong": "Password length cannot be greater than 18 digits",
    "captchaTips": "Incorrect verification code input",
    "confirmNot": "The filled password is inconsistent with the confirmed password",
    "inputAccount": "Please enter account number",
    "inputPassword": "Please enter the password",
    "inputCaptcha": "Please enter the verification code.",
    "forgetPassword": "Forget password",
    "nextStep": "Next step",
    "inputUserName": "Please enter user name",
    "phoneNumber": "Cell phone number",
    "phoneEmpty": "Mobile phone number cannot be empty",
    "surePasswordEmpty": "The confirmation password cannot be empty",
    "userNameEmpty": "User name cannot be empty",
    "getCaptcha": "Get verification code",
    "msgCaptcha": "SMS verification code",
    "prevStep": "Last step",
    "surePassword": "Please confirm the password",
    "reset": "Reset",
    "resetSuccess": "Reset succeeded",
    "resetSuccessTips": "You have successfully reset your password. Please log in",
    "loginNow": "Log in immediately",
    "copyRight": "Copyright is owned by XXX, Copyright@2020 Beijing ICP for the record",
    "loginFail": "Login failed, please try again!",
    "captchaFail": "Verification code verification failed",
    "failTips": "Verification failed",
    "inputOrigPassword": "Please enter the original password",
    "inputNewPassowrd": "Please enter a new password",
    "confimPassword": "Please confirm the password",
    "sure": "Determine",
    "cancel": "Cancel",
    "changePasswordSuccess": "Password changed successfully",
    "continueLogin": "Re-login",
    "resetLoginTips": "You have successfully changed your password and need to log in again. You will automatically exit after 3 seconds",
    "passwordFormat": "The password is 8 to 32 digits long and contains numbers and upper and lower case letters",
    "changePassword": "Modify password",
    "poor": "Weak",
    "middle": "Middle",
    "strong": "Strong",
    "logout": "Logout succeeded",
    "formerPhone": "Original mobile phone number",
    "newPhone": "Novice phone number",
    "changePhoneSuccess": "Mobile phone number modified successfully",
    "changePhoneSuccessTips": "You have successfully modified your mobile phone number",
    "goHome": "Go to homepage",
    "changePhone": "Modify mobile phone number",
    "newPhoneEmpty": "The new mobile phone number cannot be empty",
    "newPhoneFomat": "The format of the new phone number is incorrect",
    "newPhoneSupport": "The new mobile phone number cannot be consistent with the original mobile phone number",
    "newPhoneBinded": "The new mobile phone number is bound",
    "orgPhoneEmpty": "Original mobile phone number cannot be blank",
    "orgPhoneFormat": "The original mobile phone number format is incorrect",
    "orgPhoneNot": "The original mobile phone number is incorrect",
    "resetPassword": "Reset password",
    "phoneCaptchaEmpty": "Mobile phone verification code cannot be blank",
    "accountVerif": "Account number verification",
    "phoneVerif": "Mobile phone authentication",
    "resetDone": "Reset complete",
    "phoneFormat": "The format of mobile phone number is incorrect",
    "phoneBinded": "The mobile phone number has been bound",
    "loginVertif": "Login authentication",
    "clickGoHome": "Click to return to the login page",
    "bingPhoneSuccess": "Binding mobile phone number succeeded",
    "rightMessageChange": "You can modify it at the personal information on the right side of the navigation bar",
    "bingPhone": "Bind mobile phone number"
  },
  "index": {
    "setAsHomePage": "Set as home page",
    "addCollection": "Add favorites",
    "telephone": "Advisory telephone",
    "Help": "Help center",
    "SystemMessage": "System reminder",
    "message": "Message",
    "emptyMessage": "Empty",
    "checkAllMessage": "View all",
    "noMessage": "No data at present",
    "fullScreen": "Full screen display",
    "ExitSystem": "Exit this system",
    "back": "Return",
    "top": "Top",
    "backToTop": "Back to top",
    "homePage": "home page",
    "course": "Course learning",
    "onlineCourse": "Online special class",
    "faceCourse": "Face to face training class",
    "examPractice": "Examination exercises",
    "dataDownLoad": "Resource download",
    "userInfo": "Personal center",
    "Administration": "Manage background",
    "courseCategory": "Course classification",
    "examIsOver": "The assessment is completed",
    "onlineHours": "Online class hours",
    "faceHours": "Face to face hours",
    "notice": "announcement",
    "checkAllNotice": "View all",
    "backToTopButton": "Back to top",
    "recommendCourse": "Recommended courses",
    "impotentCourse": "Key courses",
    "newCourse": "Latest courses",
    "hotCourse": "Hottest course",
    "requiredCourses": "Compulsory course",
    "electiveCourses": "Elective course",
    "startStudy": "Start learning",
    "continueStudy": "Continue learning",
    "coursesRanking": "Elective ranking list",
    "studentRanking": "Student Rankings",
    "currentUser": "Active user",
    "userHead": "User avatar",
    "currentHead": "Current avatar",
    "change": "Modify",
    "accountPassword": "Account password",
    "encryPhone": "Mibao mobile phone",
    "currentPhone": "Current mobile phone",
    "userName": "User name",
    "head": "Head portrait",
    "coverImage": "Cover picture",
    "uploadError": "Upload failed",
    "autoSetHomeTips": "Your browser does not support automatic home page setting, please use the browser menu to set it manually!",
    "operateConfig": "This operation was rejected by the browser. If you want to enable this function, please enter about:config in the address bar, and then set the value of the item signed. applets.codebase _ principal _ support to true",
    "favoriteTips": "Due to the limitation of 360 browser function, please press Ctrl+D to manually collect!",
    "autoFavorite": "Your browser does not support it. Please press Ctrl+D to collect it manually!",
    "required": "This field is required",
    "to": "To",
    "trainingTime": "Training time",
    "coursehours": "Hours",
    "human": "people",
    "wecome": "Welcome you!",
    "allCourses": "All courses"
  },
  "course": {
    "coursesCategory": "Course classification",
    "allCourses": "All courses",
    "electiveCourses": "Elective course",
    "requiredCourses": "Compulsory course",
    "collect": "Collection",
    "cancelCollect": "Cancel collection",
    "searchTips": "Please enter the course name",
    "startStudy": "Start learning",
    "continueStudy": "Continue learning",
    "cancelConfirm": "Cancel collection",
    "cancelTips": "Are you sure to cancel the prompt",
    "confirmButton": "cancel button",
    "count": "general",
    "item": "Article",
    "up": "Previous page",
    "next": "Next page",
    "items": "Articles/pages",
    "go": "Jump to",
    "page": "Page",
    "man": "people",
    "score": "points",
    "courseYear": "Year",
    "courseTeachers": "Teacher",
    "noDesc": "No brief introduction yet",
    "teachersDesc": "Teacher profile",
    "checkLog": "View records",
    "reExam": "Re-examination",
    "examLog": "Examination record",
    "viewPaper": "Check the test paper",
    "noPublicExam": "This test paper will not be published",
    "marking": "In marking",
    "closeButton": "Close",
    "examResultPage": "Examination result page",
    "examPage": "Exam page",
    "startExam": "Start the exam",
    "coursehours": "Hours",
    "courseInfo": "Course details",
    "courseChapter": "Course chapter",
    "courseNote": "Course notes",
    "courseData": "Course materials",
    "courseExamination": "In-class exam",
    "evaluate": "Evaluation",
    "courseEvaluate": "Curriculum evaluation",
    "no": "No.",
    "chapter": "Chapter",
    "isEvaluate": "Has been evaluated",
    "uploadDate": "Upload time",
    "className": "Class name",
    "resourceSize": "Resource size",
    "donwButton": "Under &nbsp; carry",
    "times": "next",
    "typeViedo": "video",
    "typeImage": "Picture",
    "typeDoc": "Document",
    "typeOuth": "Other",
    "typeImages": "Multiple pictures",
    "newComment": "Latest",
    "hotComment": "Hottest",
    "openComment": "I want to comment",
    "cancelButton": "Cancel",
    "publishButton": "Release",
    "commentTips": "Please enter comments",
    "emptyCommentTips": "Comment content cannot be blank",
    "noteSource": "Derived from",
    "deleteNoteButton": "Delete",
    "needIETips": "The current courseware needs to use IE browser!",
    "donwNum": "Download times",
    "preview": "Preview",
    "relatedCourses": "Related courses",
    "studentsNum": "Number of elective courses",
    "courseHours": "Course hours",
    "JoinLearning": "Join the study"
  },
  "onlineclass": {
    "allTheClass": "All classes",
    "beginClass": "Class has started",
    "notBeginClass": "Not working",
    "endClass": "Closed shift",
    "searchThoseClass": "Search the online special classes you are interested in",
    "startLearn": "Enter the class",
    "registrationTime": "Registration time",
    "to": "To",
    "trainingTime": "Training time",
    "subjectsClass": "A course",
    "classStudy": "Class study",
    "quantityOfCourses": "Number of courses",
    "numberOfParticipants": "Number of applicants",
    "registerNow": "Sign up now",
    "resetRegister": "Withdraw registration",
    "participating": "Participated in",
    "subjects": "Door",
    "classExam": "Class exam",
    "notParticipat": "Not involved",
    "startExim": "Start the exam",
    "handed": "hand in an examination paper",
    "score": "Score",
    "cacheSave": "temporary storage",
    "subjectsNumber": "Number of doors",
    "notice": "notice",
    "communication": "Communication",
    "detail": "Details",
    "courses": "Course",
    "allClass": "All",
    "compulsory": "obligatory",
    "elective": "Elective",
    "Learned": "Completed",
    "classPassIndicator": "Class passing index",
    "excellence": "Excellent",
    "compulsoryNumber": "Required number of passes",
    "electiveNumber": "Number of elective passes",
    "compulsoryStandard": "Compulsory compliance hours",
    "electiveStandard": "Elective compliance hours",
    "examIsPass": "Did you pass the exam",
    "resource": "Resources",
    "source": "data",
    "new": "Latest",
    "hot": "Hottest",
    "updateTime": "Upload time",
    "downloadCount": "Downloads",
    "download": "download",
    "resourceSize": "Resource size",
    "resourceType": "Type",
    "allType": "All types",
    "videos": "video",
    "images": "Picture",
    "document": "Document",
    "others": "Other",
    "multiImages": "Multiple pictures",
    "inforCertificate": "Certificate",
    "notSubmit": "Not submitted",
    "submitHomework": "Submit job",
    "submitTime": "Submission time",
    "uploadHomework": "Upload job",
    "clickHere": "click here",
    "upload": "Upload",
    "formatSupport": "File format support",
    "submited": "Submitted.",
    "notApproved": "Unaudited",
    "approved": "Pass the audit",
    "downloadHomework": "Download job",
    "reSubmit": "Resubmit",
    "myScore": "My score",
    "comments": "Comments",
    "talk": "discuss",
    "category": "Classification",
    "classTalk": "Class discussion",
    "groupTalk": "Panel discussion",
    "wantTalk": "I want to discuss",
    "publish": "Release",
    "undo": "Cancel",
    "delete": "Delete",
    "iknow": "I know",
    "faceCourseClass": "Face to face training class",
    "onlineClasses": "Online special class",
    "openReservation": "Open registration",
    "talkTech": "Lecturer",
    "address": "Location",
    "up": "on",
    "noon": "noon",
    "down": "under",
    "even": "Late",
    "classOvered": "Class has been closed",
    "nopassed": "Not yet registered",
    "inputTalkContent": "Please enter the discussion content",
    "groupMan": "Leader",
    "showAllGroup": "View all team members",
    "hideAllGroup": "Pack up all the team members",
    "showAllMan": "View all students",
    "hideAllMan": "Pack up all the students",
    "reply": "Reply",
    "isDelete": "Are you sure you want to delete?",
    "cancelLike": "Cancel the praise",
    "classNotStar": "Class registration has not yet started",
    "classIsEnd": "Class registration has ended",
    "clickReset": "Click on the button to withdraw the registration",
    "agentRegister": "Sign up again",
    "cancelRegister": "Cancel the registration",
    "reason": "Reason",
    "inputReason": "Please enter the revocation reason",
    "homework": "work",
    "leaveMaxBits": "The reason for leave cannot exceed 100 words at most",
    "leaveNotEndTime": "Leave start time cannot be equal to end time",
    "sizeNot": "Size cannot exceed",
    "close": "Close",
    "teacher": "Teacher",
    "noIntroduction": "No brief introduction yet"
  },
  "offlineclass": {
    "fullTimeToFace": "Full-time face-to-face teaching",
    "onlineToFace": "On-the-job interview",
    "allClass": "All classes",
    "openClass": "Open class",
    "searchThoseClass": "Search for the face-to-face training classes you are interested in",
    "startLearn": "Enter learning",
    "classHours": "Class hours",
    "h": "When",
    "firstWeek": "Week 1",
    "askLeave": "I want to ask for leave.",
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "fridays": "Friday",
    "saturdays": "Saturday",
    "sunday": "Sunday",
    "morning": "Morning",
    "afternoon": "Afternoon",
    "evening": "Night",
    "leaveType": "Leave type",
    "selectLeaveType": "Please select leave type",
    "leaveTime": "Leave time",
    "selctLeaveTime": "Please select the leave time",
    "reasonLeave": "Reasons for leave",
    "inputReasonLeave": "Please enter the reason for leave",
    "sure": "Determine",
    "selectTime": "selection time",
    "casualLeave": "private affair leave",
    "sickLeave": "Sick leave",
    "seven": "day",
    "one": "One",
    "two": "Two",
    "three": "Three",
    "for": "Four",
    "five": "Five",
    "six": "Six",
    "clear": "Empty",
    "evaluating": "Assessment",
    "courseEvaluation": "Teaching evaluation",
    "inputEvaluating": "Please enter the evaluation content",
    "beDoing": "progressive tense",
    "notStarted": "Not started",
    "evaluationInProgress": "Evaluation in progress",
    "notEvaluation": "Not evaluated",
    "evaluationStartTime": "Evaluation start time",
    "startEvaluation": "Start evaluation",
    "classEvaluation": "Class evaluation",
    "photoCategory": "Album classification",
    "learningActivity": "Learning activities",
    "addPhoto": "Add photos",
    "photoMessage": "Photo information",
    "photoName": "Photo name",
    "inputPhotoName": "Please enter a photo name",
    "uploadPhoto": "Upload photos",
    "formatSupport": "Support format support",
    "tickets": "Zhang",
    "group": "group",
    "notGroup": "Ungrouped",
    "groupTalk": "Group discussion",
    "teacherAbout": "Teacher profile",
    "teacherTech": "Courses received",
    "photos": "Album",
    "phontoRequier": "Photos must be transmitted",
    "addPhoneTips": "Added successfully, please wait for approval",
    "sureDelete": "Are you sure you want to delete it",
    "deleteSuccess": "Delete succeeded",
    "phoneNameReq": "Photo name field is required",
    "longNotBits": "The length cannot exceed 50 characters",
    "phoneIsOccur": "Photo name already exists",
    "evaluateTime": "Evaluation time",
    "evalueteNotStar": "Evaluation did not start",
    "evaluateEnds": "Evaluation has ended",
    "isEvaluated": "Has been evaluated",
    "at": "In",
    "submit": "Submit",
    "seeEvalute": "View evaluation",
    "inputIdea": "Please enter your thoughts",
    "submitFailure": "Paper submission failed",
    "seeRecord": "View records",
    "examRecord": "Examination record",
    "seeSubmite": "Check the test paper",
    "resultPage": "Examination result page",
    "hoursStandard": "The class hours are not up to standard, and you can't take the exam",
    "examPage": "Exam page",
    "questionnaire": "Questionnaire",
    " coursesTaught": "Courses taught",
    "passed": "via",
    "is": "Yes",
    "not": "no",
    "passedState": "Pass status",
    "sketch": "draft",
    "partySchool": "Party school training class",
    "searchPartySchool": "Search the party school training classes you are interested in"
  },
  "exam": {
    "answerWarning": "The topic of this exam is irreversible. Please be careful before the next one",
    "inputAnswerTips": "Please enter your answer",
    "problemPoints": "Analysis of topic points",
    "examination": "Sign up for the exam",
    "knowledgeCompetition": "Knowledge contest",
    "practice": "Autonomous practice",
    "notRegister": "Not registered",
    "reviewAudit": "Under review",
    "auditNoPass": "Audit failed",
    "participanted": "Has signed up",
    "participant": "sign up",
    "examTime": "Examination time",
    "examHours": "duration",
    "registration": "Sign up successfully",
    "reRegistration": "Withdraw registration",
    "wrongQuestion": "Wrong question bank",
    "noInvolvement": "Not involved",
    "involvement": "Participated in",
    "searchExamPractice": "Search for exams and exercises that interest you",
    "practiced": "Worked out",
    "startPractice": "Start practicing",
    "toFavorite": "Add to collection",
    "prevPrevious": "Previous question",
    "nextPrevious": "Next question",
    "submitAnswers": "Submit answers",
    "rightAnswers": "Correct answer",
    "yourAnswers": "Your answer",
    "questionsAnalysis": "Analysis of test questions",
    "noAnalysis": "No resolution at present",
    "accuracy": "Correct rate",
    "continuePracticed": "Keep practicing",
    "topics": "subject"
  },
  "source": {
    "allResource": "All resources",
    "commonResource": "Universal resources",
    "classResource": "Class resources",
    "resourceCategory": "Resource classification",
    "searchResource": "Search for resources you are interested in",
    "resourceTalk": "resource appraisal",
    "previewResource": "Resource preview",
    "helpPoint": "Help manual",
    "isEvaluation": "You have already evaluated it!",
    "selectEvaluation": "You have not selected scoring!",
    "evaluationSuccess": "Evaluation is successful",
    "topRelise": "Topping",
    "className": "Class name",
    "resourceEvaluation": "Resource scoring"
  },
  "usercenter": {
    "386": "Learning archives",
    "myCourse": "My course",
    "hours": "When",
    "loginAccount": "Login account",
    "htllo": "Hello",
    "welcomeMessage": "I wish you happy every day",
    "underway": "You're doing it",
    "annualAssessment": "Annual assessment in",
    "searchTips": "Enter the course name for the search",
    "completed": "Have finished learning",
    "allCourses": "All courses",
    "requiredCourses": "Compulsory course",
    "electiveCourses": "Elective course",
    "all": "All",
    "ongoing": "In progress",
    "learnTo": "Learn to",
    "inExams": "take an examination",
    "noExams": "There is no exam yet",
    "delete": "Delete",
    "pleaseSelect": "Please choose",
    "searchOnlineTips": "Search for special online classes you are interested in",
    "passedCourse": "Has passed",
    "failedCourse": "Not through",
    "myOnlineCourse": "My online special class",
    "myFaceCourse": "My face-to-face training class",
    "searchFaceTips": "Search for courses you are interested in",
    "myExams": "My exams",
    "allExams": "All exams",
    "makeUpExam": "Pending make-up exam",
    "marking": "In marking",
    "onExam": "The exam is in progress",
    "passedExam": "The exam has passed",
    "examHours": "Examination duration",
    "examOver": "The exam is over",
    "exam": "examination",
    "examLog": "Examination record",
    "myScore": "My score",
    "surplusMakeUpExam": "Remaining make-up exam",
    "times": "next",
    "searchExamTips": "Enter a name for the search",
    "haveTime": "Residual time",
    "question": "topic",
    "eachQuestion": "Every question",
    "score": "points",
    "examExplain": "Exam instructions",
    "confirmHandExams": "Confirm submission",
    "autoSaveFailed": "Auto save failed",
    "autoSaveSuccess": "Auto save",
    "handExamsSuccess": "Paper submitted successfully",
    "yourScore": "Your score",
    "noPublicAnswers": "The answer will not be announced in this exam",
    "noPublicResult": "This test paper will not be published",
    "reExam": "Re-examination",
    "practice": "practice",
    "hasCollected": "Collected.",
    "emptyAnswer": "Option or answer content cannot be blank",
    "isCorrect": "Is positive solution",
    "myCollected": "My collection",
    "courseCollected": "Course collection",
    "examCollected": "test questions",
    "deleteCollected": "Remove favorites",
    "myLeave": "My leave of absence",
    "allLeave": "Take all leave",
    "needAudit": "Pending review",
    "auditDate": "Application time",
    "searchLeaveTips": "Search for leave you are interested in",
    "checkInfo": "View details",
    "cancelLeave": "Withdraw leave",
    "leaveInfo": "Leave details",
    "leaveState": "current state",
    "teamLeader": "Group leader",
    "committeeMembers": "Organize discipline inspection Committee members",
    "headmaster": "class teacher",
    "schoolLeader": "school leader",
    "student": "Students",
    "auditMessage": "Approval reason",
    "onBusiness": "on business",
    "personal": "For personal reasons",
    "rejectReasons": "Reasons for rejection",
    "confirmCancel": "Confirm whether to cancel the leave",
    "cancelButton": "repeal",
    "cancelTitle": "Cancel confirmation",
    "empty": "No",
    "wrongQuestionBank": "My wrong question bank",
    "searchWrongTips": "Search for the wrong questions you are interested in",
    "deleteWrongQuestion": "Remove the wrong question bank",
    "myQuestionnaire": "My questionnaire",
    "isCompleted": "Completed",
    "isOver": "Has ended",
    "searchQuestionnaireTips": "Enter the name of the searched questionnaire",
    "questionnaireDate": "Questionnaire time",
    "startQuestionnaire": "Start the answer",
    "checkQuestionnaire": "View questionnaire",
    "allTeacher": "All teachers",
    "newTeacher": "New teachers",
    "searchTeacherTips": "Search for teachers you are interested in",
    "checkTeacher": "examine",
    "editTeacher": "Edit",
    "workingIn": "Serve at",
    "location": "Permanent location",
    "confirmDelete": "Delete confirmation",
    "confirmDeleteTips": "Are you sure to delete",
    "recommendTeacher": "Teacher recommendation",
    "addTeachers": "New teachers",
    "teacherInfo": "Personal information",
    "teacherName": "Teacher's name",
    "workUnit": "Employment unit",
    "contact": "Contact information",
    "teacherNameTips": "Please enter the name of the teacher",
    "teacherWorkUnitTips": "Please enter the employing unit",
    "teacherContactTips": "Please enter the teacher's contact information",
    "teacherLocationTips": "Please enter the permanent location",
    "teacherDescTips": "Please enter the teacher profile",
    "teachingInfo": "Teaching information",
    "teachingExpertise": "Teaching expertise",
    "fitLevel": "Suitable for the class level",
    "fitBusiness": "Suitable for business lines",
    "ruleNumber": "Please enter an integer within 8 digits (including 8)",
    "rulePhone": "Please enter the correct mobile phone number",
    "ruleString": "Please enter characters within 80 digits (inclusive)",
    "ruleIsNumber": "Please enter the number",
    "pause": "temporary storage",
    "teachingStyle": "Lecture style",
    "teachingExpertiseTips": "Please enter the teacher's teaching expertise",
    "fitLevelTips": "Please select the level suitable for the teaching object",
    "fitBusinessTips": "Please select a suitable business line",
    "chargeInfoTips": "Please enter the charging standard",
    "teachingStyleTips": "Please enter the teacher's lecture style",
    "otherInfo": "Other information",
    "recommendUnit": "Recommended units",
    "otherOption": "Other matters",
    "otherOptionTips": "Please enter other items that need to be supplemented",
    "isRequired": "This field is required",
    "pauseSuccess": "Staging succeeded",
    "phoneWrong": "Please enter the correct mobile phone number",
    "junior": "Junior high school students",
    "highSchool": "High school student",
    "english": "english",
    "mathematics": "Mathematics",
    "recommendSuccessTips": "You have successfully submitted the recommended teacher, and the teacher will join the teacher pool after passing the examination",
    "goBackrecommend": "Back to teacher recommendation",
    "checkTeacherInfo": "View teachers",
    "currentState": "current state",
    "chargeInfo": "Charge standard",
    "myCertificate": "My certificate",
    "learningArchives": "Learning archives",
    "allCertificate": "All certificates",
    "onlineCourse": "Online class",
    "faceCourse": "Face class",
    "exams": "examination",
    "baseInfo": "Basic information",
    "userName": "User name",
    "name": "Name",
    "company": "Work unit",
    "learningExperience": "Learning resume",
    "assessmentIndex": "indicators for performance check",
    "assessmentStatus": "Examination status",
    "assessmentTime": "Examination time",
    "onlineLearning": "Online learning",
    "year": "year",
    "faceOutProduceHours": "Face-to-face full-time (class hours)",
    "notFaceOutProduceHours": "Non-full-time face-to-face teaching (class hours)",
    "onlineCenterLearnHours": "Online intensive study (class hours)",
    "onlineSelfLearnHours": "Online autonomous learning (hours)",
    "outCompanyLearnHours": "Outside unit study (hours)",
    "allHours": "Total hours",
    "onlineSelfLearn": "Autonomous online learning",
    "onlineCentralizedLearning": "Online concentrated learning",
    "outCompanyLearn": "External unit learning",
    "faceTrain": "Face to face training",
    "myNotice": "My news",
    "noticeSearchTips": "Search for news that interests you",
    "systemNotice": "System reminder",
    "message": "PRIVATE LETTER"
  },
  "questionnaire": {
    "notParticipat": "Not involved",
    "description": "Questionnaire description",
    "save": "Save",
    "export": "Export",
    "printing": "Print",
    "handed": "hand in an examination paper",
    "topics": "subject",
    "examList": "Test questions list",
    "tableQuestions": "Table questions",
    "newLine": "Add line",
    "deleteLine": "delline",
    "sort": "Serial number",
    "content": "Content",
    "shortQuestion": "Short Answer Questions",
    "inputContent": "Please enter the answer",
    "multiple": "Multiple choice",
    "single": "Single topic selection",
    "saveSuccess": "Saved successfully",
    "submitSuccess": "Submitted successfully",
    "submitTips": "You have successfully submitted the questionnaire, thank you for your participation",
    "closePage": "Close this page"
  },
  "play": {
    "endStudy": "End study",
    "tips": "Warm tip",
    "playTips": "Tips: To ensure that your study time is recorded normally by the system, please click the \"End Study\" button in the upper right corner to quit your study. If you close the browser directly, your study time may not be recorded normally.",
    "notShowAgain": "Don't prompt this message again",
    "gotIt": "I know",
    "chapter": "Chapter",
    "chapterText1": "No.",
    "chapterText2": "Chapter",
    "note": "Notes",
    "noteBlockTitle": "Notes",
    "evaluate": "Evaluation",
    "evaluateStar": "Star",
    "saveEvaluate": "Submit",
    "notePlaceholder": "Please enter notes",
    "closeTips": "Your changes may not be saved",
    "closeButton": "Leave",
    "autoStop": "Automatically stop playing",
    "autoStopTips": "Because you haven't operated for a long time, the system automatically stopped playing the video.",
    "confirmOut": "Are you sure you want to quit playing?",
    "closeOrNot": "Close the current window",
    "noCoursePlay": "There is no playable courseware in the current course",
    "attention": "Attention, please!"
  }
};